import { setup } from 'xstate';

import { type ModalMachineContext, type ModalMachineEvents } from './modal-machine.types';
import { Actions, Guards } from './setup';

// ────────────────────────────────────────────────────────────────────────────────

export const modalMachine = setup({
  types: {
    context: {} as ModalMachineContext,
    events: {} as ModalMachineEvents,
  },
  actions: Actions,
  guards: Guards,
}).createMachine({
  id: 'sgGarnishModalMachine',
  context: { active: false },
  type: 'parallel',
  states: {
    //
    // ─── VISIBILITY ─────────────────────────────────────────────────────────
    //

    visibility: {
      initial: 'initializing',
      states: {
        initializing: {
          meta: { description: 'Resolves the initial visibility.' },
          always: [{ target: 'shown', guard: 'checkIfInitiallyShown' }, { target: 'dismissed' }],
        },

        shown: {
          meta: { description: 'The modal is fully shown.' },
          on: {
            DISMISS: 'dismissed',
          },
          entry: ['setActive'],
        },

        dismissed: {
          meta: { description: 'The modal is fully dismissed.' },
          on: {
            SHOW: 'shown',
          },
          entry: ['setInactive'],
        },
      },
    },

    //
    // ─── ANIMATION ──────────────────────────────────────────────────────────
    //

    animation: {
      initial: 'idle',
      states: {
        idle: {
          on: {
            START_SHOW: {
              target: 'showing',
              guard: 'checkIfDismissed',
            },
            START_DISMISS: {
              target: 'dismissing',
              guard: 'checkIfShown',
            },
          },
        },

        showing: {
          meta: { description: 'Show animation in progress.' },
          on: {
            '*': 'idle',
            START_DISMISS: 'dismissing',
          },
        },

        dismissing: {
          meta: { description: 'Dismiss animation in progress.' },
          on: {
            '*': 'idle',
            START_SHOW: 'showing',
          },
        },
      },
    },
  },
});
